import React, { useContext, useState } from "react";
import {
  DndContext,
  DragOverlay,
  closestCenter,
  useDroppable,
} from "@dnd-kit/core";
import ColumnItem from "./ColumItem";
import { types } from "../../../types/types";
import { ChatContext } from "../../../context/chat/ChatContext";
import { SocketContext } from "../../../context/SocketContext";
import ItemUs from "./ItemUs";

const Board = ({ openChat }) => {
  const { chatState, dispatch } = useContext(ChatContext);
  const { chatsLists: columns } = chatState;
  const { socket } = useContext(SocketContext);
  const [activeItem, setActiveItem] = useState(null);

  const columnNames = Object.keys(columns);
  const handleDragStart = (event) => {
    const { active } = event;

    if (!active?.id) return;

    const [fromColumn, chatId] = active.id.split("-");

    const fromItems = columns[fromColumn];
    const item = fromItems?.find((i) => i.id_user?.toString() === chatId);

    if (item) {
      setActiveItem(item);
    }
  };
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over || !active.id || !over.id) return;

    const [fromColumn, chatId] = active.id.split("-");
    const [toColumn, toIndex] = over.id.split("-");

    // Si no hay cambio de columna, no hacemos nada aquí
    if (fromColumn === toColumn) return;

    const fromItems = [...columns[fromColumn]];
    const toItems = [...columns[toColumn]];

    // Buscar y remover el ítem de origen por ID numérico
    const movedItemIndex = fromItems.findIndex(
      (item) => item.id_user?.toString() === chatId
    );

    if (movedItemIndex === -1) return;

    const [movedItem] = fromItems.splice(movedItemIndex, 1);

    // Insertar el ítem en la nueva posición de destino
    const newIndex = parseInt(toIndex);
    if (!isNaN(newIndex)) {
      toItems.splice(newIndex, 0, movedItem);
    } else {
      toItems.push(movedItem); // Si no se puede determinar, lo agregamos al final
    }

    // Actualizar estado
    dispatch({
      type: types.loadChatsCat,
      payload: {
        ...columns,
        [fromColumn]: fromItems,
        [toColumn]: toItems,
      },
    });

    // Emitir por socket
    socket.emit("chatmoved", {
      chatId: movedItem.id_user,
      from: fromColumn,
      to: toColumn,
    });
    setActiveItem(null);
  };
  function DroppableZone({ id, title, children }) {
    const { isOver, setNodeRef } = useDroppable({ id });

    const style = {
      flex: 1,
      minHeight: "200px",
      padding: "16px",
      backgroundColor: isOver ? "#e0ffe0" : "#f8f9fa",
      borderRadius: "12px",
      margin: "0 10px",
    };

    return (
      <div ref={setNodeRef} style={style}>
        <h4 style={{ textAlign: "center", marginBottom: "16px" }}>{title}</h4>

        <hr />
        {children}
      </div>
    );
  }
  return (
    <DndContext
      onDragEnd={handleDragEnd}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
    >
      <div className="d-flex overflow-auto gap-3">
        {columnNames.length > 0 ? (
          columnNames.map((key) => (
            <div className="flex-shrink-0" style={{ width: "300px" }} key={key}>
              <ColumnItem
                id={key}
                title={key
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (l) => l.toUpperCase())}
                items={columns[key] || []}
                openChat={openChat}
              />
            </div>
          ))
        ) : (
          <p className="px-2">No hay categorías cargadas</p>
        )}
      </div>
      <DragOverlay>
        {activeItem ? (
          <div
            style={{
              padding: "12px 16px",
              // backgroundColor: "#20D7E4FF",
              color: "white",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            }}
          >
            <ItemUs key={activeItem.id} user={activeItem} id={0} />
          </div>
        ) : null}
      </DragOverlay>
    </DndContext>
  );
};

export default Board;
